import { EditRecipeArgs, MediaAndSource, UserRecipe } from "@eatbetter/recipes-shared";
import { useDispatch } from "../lib/AdminRedux";
import { displayUnexpectedErrorAndLog, EditUserRecipeOnSaveArgs, RecipeEditControl } from "@eatbetter/ui-shared";
import { addPhoto } from "../lib/photos/AdminPhotoThunks";
import { editUserRecipeOnBehalfOfUser } from "../lib/recipes/AdminRecipesThunks";
import { View } from "react-native";
import { defaultTimeProvider } from "@eatbetter/common-shared";

export const EditUserRecipe = (props: { initialRecipe: UserRecipe; onDone: () => void }) => {
  const dispatch = useDispatch();

  const onSave = async (args: EditUserRecipeOnSaveArgs) => {
    // We don't currently support multi-photo edit in admin and the UX should prevent it, but worth checking here as well
    if (args.newRecipePhoto && args.media && args.media.length > 1) {
      displayUnexpectedErrorAndLog(
        `Unsupported: can't set photo because recipe already has media (length ${args.media.length})`,
        {},
        { media: args.media }
      );
      return;
    }

    let media: MediaAndSource[] | undefined = undefined;

    // If there's a single photo, we allow admin editing through the old UI, but map it to the new media array
    if (args.newRecipePhoto && args.media && args.media.length === 1) {
      const oldPhoto = args.media[0]?.media;

      if (oldPhoto && oldPhoto.type !== "photo") {
        displayUnexpectedErrorAndLog(
          "Unexpected media type updating recipe photo",
          {},
          { media: args.media, newRecipePhoto: args.newRecipePhoto }
        );
        return;
      }

      const newPhoto = await dispatch(addPhoto(args.newRecipePhoto));

      media = [
        {
          type: "photo",
          photo: newPhoto,
          source: {
            type: "user",
          },
        },
        // Remove the old photo, if there was one
        ...(oldPhoto
          ? [
              {
                ...oldPhoto,
                deleted: defaultTimeProvider(),
              },
            ]
          : []),
      ];
    } else if (args.media) {
      media = args.media.map(i => i.media);
    }

    const editArgs: EditRecipeArgs = {
      id: props.initialRecipe.id,
      version: props.initialRecipe.version,
      description: args.description,
      ingredients: args.ingredients,
      instructions: args.instructions,
      title: args.title,
      media,
      time: args.time,
      recipeYield: args.recipeYield,
    };

    await dispatch(editUserRecipeOnBehalfOfUser(editArgs));
    props.onDone();
  };

  return (
    <View>
      <RecipeEditControl type="adminUser" initialRecipe={props.initialRecipe} onSave={onSave} />
    </View>
  );
};
